export default "__VITE_ASSET__C4S7StpZ__"